export default __webpack_public_path__ + "5080bf2fc977c7945d44dae5e5e876e4.png";